package com.schoolconnect.app.feature.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.schoolconnect.app.feature.auth.AuthFeatureRoute
import com.schoolconnect.app.feature.attendance.AttendanceFeatureRoute
import com.schoolconnect.app.feature.calendar.CalendarFeatureRoute
import com.schoolconnect.app.feature.config.ConfigFeatureRoute
import com.schoolconnect.app.feature.exams.ExamsFeatureRoute
import com.schoolconnect.app.feature.examresults.ExamResultsFeatureRoute
import com.schoolconnect.app.feature.home.HomeFeatureRoute
import com.schoolconnect.app.feature.homework.HomeworkFeatureRoute
import com.schoolconnect.app.feature.imports.ImportsFeatureRoute
import com.schoolconnect.app.feature.itusers.ITUsersFeatureRoute
import com.schoolconnect.app.feature.links.LinksFeatureRoute
import com.schoolconnect.app.feature.notices.NoticesFeatureRoute
import com.schoolconnect.app.feature.quickannouncements.QuickAnnouncementsScreen
import com.schoolconnect.app.feature.quickannouncements.QuickAnnouncementsViewModel
import com.schoolconnect.app.feature.eventsnews.EventsNewsFeatureRoute
import com.schoolconnect.app.feature.schoolusers.SchoolUsersFeatureRoute
import com.schoolconnect.app.feature.students.StudentsFeatureRoute
import com.schoolconnect.app.feature.mystudents.TeacherMyStudentsFeatureRoute
import com.schoolconnect.app.feature.splash.SplashFeatureRoute
import com.schoolconnect.app.feature.schoolstaff.SchoolStaffFeatureRoute
import com.schoolconnect.app.feature.teachers.TeachersFeatureRoute
import com.schoolconnect.app.feature.common.featureCatalog

@Composable
fun FeatureRouteHost(
    featureId: String,
    onBack: () -> Unit,
    onAuthenticated: (String, String, String) -> Unit = { _, _, _ -> },
    onOpenFeature: (String) -> Unit = {},
    onToggleTheme: () -> Unit = {},
    onLogout: () -> Unit = {},
    homeRoleCode: String = "",
    homeSchoolLabel: String = "iConnect.School",
    homeSchoolId: String = "",
    homeSchoolCode: String = "",
    initialSelectedNavId: String = "dashboard",
    onHomeRoleChanged: (String, String, String) -> Unit = { _, _, _ -> },
    features: List<FeatureEntry> = featureCatalog
) {
    when (featureId) {
        "home" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = initialSelectedNavId,
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "auth" -> AuthFeatureRoute(
            onBack = onBack,
            onAuthenticated = onAuthenticated
        )
        "splash" -> SplashFeatureRoute()
        "schools" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = "schools",
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "school-users" -> SchoolUsersFeatureRoute(
            onBack = onBack,
            shellRoleCode = homeRoleCode,
            shellSchoolLabel = homeSchoolLabel,
            onChangeRole = onBack,
            onLogout = onLogout
        )
        "staff" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = "staff",
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "it-users" -> ITUsersFeatureRoute(
            onBack = onBack,
            shellRoleCode = homeRoleCode,
            shellSchoolLabel = homeSchoolLabel,
            onChangeRole = onBack,
            onLogout = onLogout
        )
        "academic-years" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = "academic-years",
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "classes" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = "classes",
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "classes-sections" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = "classes",
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "students" -> StudentsFeatureRoute(
            onBack = onBack,
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged
        )
        "my-students" -> TeacherMyStudentsFeatureRoute(
            onBack = onBack,
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged
        )
        "teachers" -> TeachersFeatureRoute(onBack = onBack, schoolId = homeSchoolId)
        "parents" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = "parents",
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "school-staff" -> SchoolStaffFeatureRoute(
            onBack = onBack,
            schoolId = homeSchoolId,
            shellRoleCode = homeRoleCode,
            shellSchoolLabel = homeSchoolLabel,
            onChangeRole = onBack,
            onLogout = onLogout
        )
        "links" -> LinksFeatureRoute(onBack = onBack)
        "subjects" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = "subjects",
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "notices" -> NoticesFeatureRoute(onBack = onBack, shellRoleCode = homeRoleCode, onChangeRole = onBack, onLogout = onLogout)
        "quick-announcements" -> {
            val viewModel = androidx.compose.runtime.remember { QuickAnnouncementsViewModel() }
            val state by viewModel.uiState.collectAsState()
            androidx.compose.runtime.DisposableEffect(viewModel) { onDispose { viewModel.clear() } }
            QuickAnnouncementsScreen(state, viewModel::onEvent, homeRoleCode, onBack, onLogout, onBack)
        }
        "events-news" -> EventsNewsFeatureRoute(schoolId = homeSchoolId, onBack = onBack, shellRoleCode = homeRoleCode, onChangeRole = onBack, onLogout = onLogout)
        "parent-notes" -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            initialSelectedNavId = "parent-notes",
            features = features,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onHomeRoleChanged = onHomeRoleChanged,
            onBack = onBack
        )
        "calendar" -> CalendarFeatureRoute(onBack = onBack)
        "attendance" -> AttendanceFeatureRoute(
            onBack = onBack,
            schoolId = homeSchoolId,
            shellRoleCode = homeRoleCode,
            shellSchoolLabel = homeSchoolLabel,
            onChangeRole = onBack,
            onLogout = onLogout
        )
        "homework" -> HomeworkFeatureRoute(
            onBack = onBack,
            shellRoleCode = homeRoleCode,
            shellSchoolLabel = homeSchoolLabel,
            onChangeRole = onBack,
            onLogout = onLogout
        )
        "exams" -> ExamsFeatureRoute(
            onBack = onBack,
            shellRoleCode = homeRoleCode,
            shellSchoolLabel = homeSchoolLabel,
            onChangeRole = onBack,
            onLogout = onLogout
        )
        "exam-results" -> ExamResultsFeatureRoute(
            onBack = onBack,
            shellRoleCode = homeRoleCode,
            shellSchoolLabel = homeSchoolLabel,
            onChangeRole = onBack,
            onLogout = onLogout
        )
        "imports" -> ImportsFeatureRoute()
        "config" -> ConfigFeatureRoute(
            onBack = onBack,
            roleLabel = homeRoleCode.ifBlank { "School Admin" },
            roleSubtitle = homeSchoolLabel,
            onChangeRole = onBack,
            onLogout = onLogout
        )
        else -> HomeFeatureRoute(
            homeRoleCode = homeRoleCode,
            homeSchoolLabel = homeSchoolLabel,
            homeSchoolId = homeSchoolId,
            homeSchoolCode = homeSchoolCode,
            onBack = onBack,
            onHomeRoleChanged = onHomeRoleChanged
        )
    }
}
